import React, { Fragment, ReactNode } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styled from 'styled-components';
import { FontStyle } from '@/utils/StyleUtil'; // requires a loader

interface IProps {
    contentArr: ReactNode[];
    currentTab: number;
    handleTab: (_: number) => void;
    options?: {
        autoPlay: boolean;
        interval: number;
        infiniteLoop: boolean;
    };
}

const DefaultCarousel = ({ contentArr, currentTab, handleTab, options }: IProps) => {
    return (
        <Carousel
            swipeScrollTolerance={140}
            swipeable
            emulateTouch
            showStatus={false}
            showIndicators={false}
            showArrows={false}
            showThumbs={false}
            onChange={handleTab}
            selectedItem={currentTab}
            autoPlay={options?.autoPlay}
            interval={options?.interval}
            infiniteLoop={options?.infiniteLoop}
        >
            {contentArr.map((item: ReactNode, index: number) => (
                <ContentContainer key={index}>
                    {item}
                    <CarouselCounter>
                        <span style={{ color: '#FFF' }}>{index + 1}</span>
                        <span>/</span>
                        <span>{contentArr.length}</span>
                    </CarouselCounter>
                </ContentContainer>
            ))}
        </Carousel>
    );
};

const ContentContainer = styled.div`
    position: relative;
`;

const CarouselCounter = styled.div`
    font-family: ForceRoboto;
    position: absolute;
    display: flex;
    padding: 4px 12px;
    align-items: center;
    gap: 2px;
    border-radius: 1000px;
    background: rgba(0, 0, 0, 0.5);
    bottom: 10px;
    right: 30px;
    ${FontStyle(14, 22, '500', '#EEE', 0)};
`;

export default DefaultCarousel;
